import { graphql, useStaticQuery } from "gatsby"

export const useGoogleReviewData = () => {
  const data = useStaticQuery(graphql`
    query GoogleReviews {
      allGooglePlacesPlace(
        filter: { childGooglePlacesReview: { rating: { eq: 5 } } }
      ) {
        nodes {
          name
          user_ratings_total
          place_id
          childrenGooglePlacesReview {
            author_name
            rating
            profile_photo_url
            text
          }
          rating
        }
      }
    }
  `)

  return data
}
